import { ViewIcon } from "@chakra-ui/icons";
import { Box, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { SharedHomework } from "../../models/SharedHomework";
import { useNavigate } from "react-router-dom";

type Props = {
  sharedHomework: SharedHomework;
};

export default function SharedHomeworkItem({ sharedHomework }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(
      `./${sharedHomework.learningPath.id}/homeworks/${sharedHomework.sharingCode}?exerciseId=${sharedHomework.exam.id}&isShared=true`,
      { state: { author: sharedHomework.user.fullName } },
    );
  }, [
    navigate,
    sharedHomework.exam.id,
    sharedHomework.learningPath.id,
    sharedHomework.sharingCode,
    sharedHomework.user.fullName,
  ]);

  return (
    <Box
      w={"100%"}
      p={4}
      bg="red.50"
      display="flex"
      flexDir="row"
      justifyContent="space-between"
      alignItems="center"
      gap={4}
    >
      <Box>
        <Text fontSize={14} color="primary.DEFAULT" fontWeight="700">
          {sharedHomework.user.fullName}
        </Text>
        <Text fontSize={18} fontWeight="500">
          {sharedHomework.learningPath.name} - {sharedHomework.exam.name}
        </Text>
        <Text>{sharedHomework.exam.description}</Text>
      </Box>
      <Tooltip label={t("common.buttons.visualize")}>
        <IconButton
          onClick={onClick}
          aria-label={t("common.buttons.visualize")}
          icon={<ViewIcon />}
        />
      </Tooltip>
    </Box>
  );
}
